var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { autocomplete: "off" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6 d-flex" },
        [
          _c(
            "vs-select",
            {
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: _vm.isMop ? "Regiones" : "Categorías",
                "description-text":
                  "Si no hay, puedes consultar con tu administrador",
                name: "category"
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.category,
                callback: function($$v) {
                  _vm.category = $$v
                },
                expression: "category"
              }
            },
            _vm._l(_vm.categoryRegions, function(region, index) {
              return _c("vs-select-item", {
                key: index,
                attrs: { value: region.opcionId, text: region.descripcion }
              })
            }),
            1
          ),
          _c("vs-icon", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Quitar filtro",
                expression: "'Quitar filtro'"
              }
            ],
            staticClass: "ml-2 mt-5 pt-3 cursor-pointer",
            attrs: { color: "danger", size: "medium", icon: "highlight_off" },
            on: {
              click: function($event) {
                return _vm.clearCategory()
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-6 d-flex" },
        [
          _c(
            "vs-select",
            {
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: _vm.isMop ? "Servicios" : "Subcategorías",
                "description-text":
                  "Si no hay, puedes consultar con tu administrador",
                name: "servicio"
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.subcategory,
                callback: function($$v) {
                  _vm.subcategory = $$v
                },
                expression: "subcategory"
              }
            },
            _vm._l(_vm.categoryServices, function(service, index) {
              return _c("vs-select-item", {
                key: index,
                attrs: { value: service.opcionId, text: service.descripcion }
              })
            }),
            1
          ),
          _c("vs-icon", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Quitar filtro",
                expression: "'Quitar filtro'"
              }
            ],
            staticClass: "ml-2 mt-5 pt-3 cursor-pointer",
            attrs: { color: "danger", size: "medium", icon: "highlight_off" },
            on: {
              click: function($event) {
                return _vm.clearSubcategory()
              }
            }
          })
        ],
        1
      ),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col 12 mt-5" }, [
      _c("small", { staticClass: "badge badge-success" }, [
        _vm._v(" Los filtros se aplican automaticamente al seleccionarlos ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }